import React from "react";

// Brand assets live in public/: logo-mark.png (icon) and logo-wordmark.png (icon + PLATEO).
export function LogoMark({ className = "brand-mark" }) {
  return <img className={className} src="/logo-mark.png" width={30} height={30} alt="" />;
}

export function LogoWordmark({ className = "brand-wordmark" }) {
  return <img className={className} src="/logo-wordmark.png" width={160} height={160} alt="Plateo" />;
}
